import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {InternalMsgService} from './services/internal.msg.service';
import {AccountService} from './services/account.service';
import {pipe, Subject, Subscription} from 'rxjs';
import {filter, takeUntil} from 'rxjs/operators';
import {
  MsalService,
  MsalBroadcastService,

} from '@azure/msal-angular';
import {
  EventMessage,
  EventType,
  InteractionStatus,
} from '@azure/msal-browser';
import {AccountItem} from './models/accountitem';
import {CurRoute} from './routehelper';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();
  // ******************************************************************

  loggedAccount: AccountItem = new AccountItem();
  selectedMenu: boolean[] = [false, true, false, false, false];
  msgSubscr: Subscription = new Subscription();
  menuIndexSubscr: Subscription = new Subscription();
  isSystemAvailable: boolean = true;
  mobileNavOpen = false;

  constructor(private router: Router,
              private authService: MsalService,
              private msalBroadcastService: MsalBroadcastService,
              private accountService: AccountService,
              private msgService: InternalMsgService) {
  }

  ngOnDestroy() {
    this.msgSubscr.unsubscribe();
    this.menuIndexSubscr.unsubscribe();
    this.accountService.logout();
  }

  ngOnInit() {
    this.authService.handleRedirectObservable().subscribe();

    this.authService.instance.enableAccountStorageEvents(); // Optional - This will enable ACCOUNT_ADDED and ACCOUNT_REMOVED events emitted when a user logs in or out of another tab or window
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) =>
          msg.eventType === EventType.ACCOUNT_ADDED ||
          msg.eventType === EventType.ACCOUNT_REMOVED
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        if (this.authService.instance.getAllAccounts().length === 0) {
          window.location.pathname = '/';
        } else {
          this.setLoginDisplay();
        }
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
          this.setLoginDisplay();
          this.checkAndSetActiveAccount();
          if (this.loginDisplay) {
            this.router.navigate(['/home']);
          }
          this.msgSubscr = this.msgService.loggedInAccountSet$
            .subscribe(account => {
              if (account) {
                this.loggedAccount = account;
                if (!this.loggedAccount.isSystemAilable) {
                  this.isSystemAvailable = false;
                }
              } else {
                this.loggedAccount = new AccountItem();
              }
            });

          this.msgSubscr = this.msgService.readyForActionSet$
            .subscribe(ready => {
              if (ready) {
                this.router.navigate(['/home']);
              }
            });

          this.menuIndexSubscr = this.msgService.selectedMenuSet$.subscribe(
            menuInx => {
              this.selectedMenu.fill(false);
              this.selectedMenu[menuInx] = true;
            });

          if (window.location.hash == '#/home') {
            this.selectedMenu.fill(false);
            this.selectedMenu[0] = true;
          } else if (window.location.hash == '#/createtimecard') {
            this.selectedMenu.fill(false);
            this.selectedMenu[1] = true;
          } else if (window.location.hash == '#/recenttimecards') {
            this.selectedMenu.fill(false);
            this.selectedMenu[2] = true;
          } else if (window.location.hash == '#/reports') {
            this.selectedMenu.fill(false);
            this.selectedMenu[3] = true;
          } else if (window.location.hash == '#/sysadmin') {
            this.selectedMenu.fill(false);
            this.selectedMenu[4] = true;
          }
        }
      );
  }

  checkAndSetActiveAccount(): void {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.authService.instance.getActiveAccount();
    if (
      !activeAccount &&
      this.authService.instance.getAllAccounts().length > 0
    ) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);

    }
  }

  setLoginDisplay(): void {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

  isTestEnv(): boolean {
    return CurRoute.isTestEnv();
  }

  isDevEnv(): boolean {
    return CurRoute.isDevelopmentEnv();
  }

  isLoggedIn(): boolean {
    return this.loggedAccount.email.trim() != '';
  }

  checkAccount(): boolean {
    return this.authService.instance.getAllAccounts().length > 0;
  }

  toggleMobileSideMenu() {
    this.mobileNavOpen = !this.mobileNavOpen;
  }

  gotoPage(pageIndex: number, pageName: string): void {
    this.selectedMenu.fill(false);
    this.selectedMenu[pageIndex] = true;
    this.router.navigate([`/${pageName}`]);
  }

  getSelected(index: number): boolean {
    return this.selectedMenu[index];
  }
}
